const recaptChaKey = process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY
export default recaptChaKey
